import { render, staticRenderFns } from "./makmin.vue?vue&type=template&id=c55d4720&"
import script from "./makmin.vue?vue&type=script&lang=js&"
export * from "./makmin.vue?vue&type=script&lang=js&"
import style0 from "./makmin.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports